/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { css, jsx } from '@emotion/react'
import React, { type FunctionComponent } from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiText, useEuiTheme } from '@elastic/eui'

type Props = {
  title: React.ReactNode
  helpText?: React.ReactNode
}

const Section: FunctionComponent<Props> = ({ title, helpText, children }) => {
  const { euiTheme } = useEuiTheme()

  return (
    <EuiFlexGroup direction='column' gutterSize='xs'>
      <EuiFlexItem>
        <EuiText
          size='xs'
          css={css({
            color: euiTheme.colors.textHeading,
            fontWeight: euiTheme.font.weight.semiBold,
          })}
        >
          {title}
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize='s' alignItems='center' responsive={false} wrap={true}>
          {children}
        </EuiFlexGroup>
      </EuiFlexItem>
      {helpText && (
        <EuiText
          size='xs'
          css={css({
            color: euiTheme.colors.backgroundFilledText,
          })}
        >
          {helpText}
        </EuiText>
      )}
    </EuiFlexGroup>
  )
}

export default Section
